import { createAsyncThunk } from '@reduxjs/toolkit';

import request from '../../modules/Request/request';

export const addHealthScore = createAsyncThunk('addHealthScore', async ({ data }, { rejectWithValue }) => {
  const response = await request('/health-score', { method: 'POST', body: data });
  if (response.success) {
    return response.data;
  }
  const error = response?.error?.message || response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getHealthInsightsList = createAsyncThunk(
  'healthInsightsList',
  async (object, { rejectWithValue }) => {
    const response = await request('/health-score/list', { method: 'GET' });
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const updateHealthScore = createAsyncThunk(
  'updateHealthScore',
  async ({ data }, { rejectWithValue }) => {
    const response = await request('/health-score/update', { method: 'PUT', body: data });
    if (response.success) {
      return response.data.response;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const deleteHealthScore = createAsyncThunk('deleteHealthScore', async (id, { rejectWithValue }) => {
  const response = await request('/health-score/delete', { method: 'DELETE', params: id });
  if (response.success) {
    return id;
  }
  const error = response?.error?.message || response.error;
  throw rejectWithValue(error || 'Something went wrong');
});

export const getHealthInsightsDetails = createAsyncThunk(
  'healthInsightsDetails',
  async ({ healthScoreId }, { rejectWithValue }) => {
    const response = await request('/health-score/details', { method: 'GET', params: healthScoreId });
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getHealthScoreRuleGraphData = createAsyncThunk(
  'RuleGraphData',
  async (object, { rejectWithValue }) => {
    const response = await request('/health-score-graph', { method: 'POST', body: object });
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const explainHealthScore = createAsyncThunk(
  'explainHealthScore',
  async ({
    accountId, healthScoreId, isShare, tenantId, accountOrgId,
  }, { rejectWithValue }) => {
    const reqPayload = {};
    reqPayload.method = 'GET';
    reqPayload.params = [accountId, healthScoreId];
    const query = {};
    if (isShare) {
      query.isShare = isShare;
      if (accountOrgId) {
        query.accountOrgId = accountOrgId;
      } else {
        query.tenantId = tenantId;
      }
    }
    reqPayload.query = query;
    const response = await request('/health-score/explain', reqPayload);
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getKpiScoreSize = createAsyncThunk(
  'getKpiScoreSize',
  async (object, { rejectWithValue }) => {
    const response = await request('/account-kpi-score-size', { method: 'GET' });
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getVersionScoreDistribution = createAsyncThunk(
  'getVersionScoreDistribution',
  async ({ packageId }, { rejectWithValue }) => {
    const response = await request('/version-kpi-distribution', { method: 'GET', params: [packageId] });
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
